export default __webpack_public_path__ + "static/media/management.87fd013e.svg";